
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PhoneCallModal() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    const handlePhoneClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a.call-trigger') as HTMLAnchorElement;
      
      if (link) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const phone = link.getAttribute('data-phone');
        if (phone) {
          setPhoneNumber(phone);
          setIsOpen(true);
        }
      }
    };

    document.addEventListener('click', handlePhoneClick, true);
    
    return () => {
      document.removeEventListener('click', handlePhoneClick, true);
    };
  }, []);

  const handleCallAnyway = () => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    }
    setIsOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleBooking = () => {
    setIsOpen(false);
    navigate('/qualified-booking');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60"
        onClick={handleClose}
      ></div>
      
      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-2xl max-w-md w-full p-6 sm:p-8 animate-fadeIn">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-[#83B328]/10 rounded-full flex items-center justify-center">
            <i className="ri-phone-line text-3xl text-[#83B328]"></i>
          </div>
        </div>

        {/* Message */}
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-3">
          High Call Volume
        </h3>
        <p className="text-gray-600 text-center mb-6 text-sm sm:text-base leading-relaxed">
          We've been receiving a high volume of phone calls. For the fastest response, please book an evaluation or use our instant pricing form.
        </p>

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleBooking}
            className="w-full bg-[#83B328] hover:bg-[#6d9620] text-white font-semibold py-3 px-6 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            Book Evaluation / Instant Form
          </button>
          
          <button
            onClick={handleCallAnyway}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            Call Anyway
          </button>
        </div>

        {/* Cancel Link */}
        <div className="text-center mt-4">
          <button
            onClick={handleClose}
            className="text-sm text-gray-500 hover:text-gray-700 underline cursor-pointer"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
